const checkNullValue = (name: any) => {
  if (name === null || name === undefined || name === 'null' || name === 'undefined') {
    return '';
  }
  return name;
};

export {checkNullValue};
